import { defineComponent as _defineComponent } from 'vue'
import { BigDecimal } from "@/models/store/big.decimal";
import { PropType } from "vue";
import { formatBigNumberLocalized, reduceBigNumberLocalized } from "@/utils/locale-number-formatter";

// const props = defineProps<{
//   amount: bigint | number | BigDecimal ,
// //   amount: [Object, Number, BigDecimal] as PropType<bigint | number | BigDecimal>,
//   precision?: number,
//   reduceBigNumber?: boolean,
// }>();

// whatever: BigInt as unknown as PropType<bigint>,


export default /*#__PURE__*/_defineComponent({
  __name: 'FormattedNumber',
  props: {
  amount: {
    type:  [Object , Number, BigDecimal] as PropType<bigint | number | BigDecimal>,
    required: true
  },
  precision: {
    type : Number,
    required: false
  } ,
  reduceBigNumber: {
    type : Boolean,
    required: false
  },
  removeDec: {
    type : Boolean,
    required: false,
    default: true
  },
},
  setup(__props, { expose: __expose }) {
  __expose();

const props =  __props;

function transformToExpView() {
  if (typeof props.amount === 'number' && isNaN(props.amount)) {
    return Number.NaN.toString(); // TODO some text?
  }
  if (props.reduceBigNumber) {
    return reduceBigNumberLocalized(props.amount, props.precision || 4);
  }
  return formatBigNumberLocalized(typeof props.amount === 'bigint' ? props.amount.toString() : props.amount.toFixed(props.precision || 4), props.removeDec);
}



const __returned__ = { props, transformToExpView }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})